"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.nodeType = exports.UIConfigSchema = exports.TaskSchema = void 0;
const zod_1 = require("zod");
const tape_sanitizer_1 = require("@finley-technologies/tape-sanitizer");
const tape_builder_base_1 = require("../../../types/tape-builder-base");
exports.TaskSchema = tape_sanitizer_1.StackTransformationSchema.omit({
    srcDataTape: true,
    otherDataTapes: true,
}).extend({
    operation: zod_1.z.literal('stack'),
    srcArtifactSlug: (0, tape_builder_base_1.zArtifactSlugRef)('Source (input) artifact slug for this operation'),
    otherArtifactSlugs: zod_1.z.array((0, tape_builder_base_1.zArtifactSlugRef)('Additional source artifact slug to stack')),
});
exports.UIConfigSchema = exports.TaskSchema.omit({
    srcArtifactSlug: true,
    otherArtifactSlugs: true,
});
exports.nodeType = 'operation_stack';
//# sourceMappingURL=types.js.map